import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import ProductModal from "@/Modals/WebDataManagement/MasterData/Products/Modal";
import React from "react";
import { columns } from "./Columns";
import { productsMasterDataApi } from "@/apis/apis";

export default function ProductsPage() {
  return (
    <MasterDataBaseTable
      label="Product"
      apiURL={productsMasterDataApi}
      columns={columns()}
      useLocalizationContent
      ModalComponent={ProductModal}
      importData={BASE_IMPORT_DATA.PRODUCTS}
    />
  );
}
